import { render, staticRenderFns } from "./modal-add-folder.vue?vue&type=template&id=72a7ef98&"
import script from "./modal-add-folder.vue?vue&type=script&lang=js&"
export * from "./modal-add-folder.vue?vue&type=script&lang=js&"
import style0 from "./modal-add-folder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports